/**
 * TypeBox schemas for Route entity — a discoverable, reusable path identity.
 */

import { Type, type Static } from 'typebox'
import { UUID, ISODate, type Exact } from './common.js'
import { OriginSchema } from './origin.js'
import { DifficultySchema } from './difficulty.js'

export const RouteSchema = Type.Object({
  id: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  description: Type.Optional(Type.String({ maxLength: 2000 })),
  difficulty: Type.Optional(DifficultySchema),
  origin: OriginSchema,
  tags: Type.Array(Type.String({ maxLength: 50 })),
  isPublic: Type.Boolean(),
  createdFrom: Type.Optional(
    Type.Object({
      type: Type.Union([Type.Literal('plan'), Type.Literal('activity')]),
      id: UUID,
    })
  ),
  createdBy: UUID,
  version: Type.Number({ minimum: 0 }),
  createdAt: ISODate,
  updatedAt: ISODate,
})
export type Route = Exact<Static<typeof RouteSchema>>

/** Fields required when creating a route */
export const RouteCreateSchema = Type.Object({
  name: Type.String({ minLength: 1, maxLength: 100 }),
  origin: OriginSchema,
  createdBy: UUID,
})

/** Partial route for updates */
export const RouteUpdateSchema = Type.Partial(RouteSchema)
